import { Col, Row } from 'reactstrap'

const GridColumnRow = () => {
  return (
    <Row>
        <Col md="1" className="text-center"><span>{'col-md-1'}</span></Col>
        <Col md="2" className="text-center"><span>{'col-md-2'}</span></Col>
        <Col md="2" className="text-center"><span>{'col-md-2'}</span></Col>
        <Col md="3" className="text-center"><span>{'col-md-3'}</span></Col>
        <Col md="4" className="text-center"><span>{'col-md-4'}</span></Col>
        <Col md="5" className="text-center"><span>{'col-md-5'}</span></Col>
        <Col md="7" className="text-center"><span>{'col-md-7'}</span></Col>
        <Col md="6" className="text-center"><span>{'col-md-6'}</span></Col>
        <Col md="6" className="text-center"><span>{'col-md-6'}</span></Col>
        <Col md="8" className="text-center"><span>{'col-md-8'}</span></Col>
        <Col md="4" className="text-center"><span>{'col-md-4'}</span></Col>
        <Col md="9" className="text-center"><span>{'col-md-9'}</span></Col>
        <Col md="3" className="text-center"><span>{'col-md-3'}</span></Col>
        <Col md="10" className="text-center"><span>{'col-md-10'}</span></Col>
        <Col md="2" className="text-center"><span>{'col-md-2'}</span></Col>
        <Col md="12" className="text-center"><span>{'col-md-12'}</span></Col>
  </Row>
  )
}

export default GridColumnRow